import { InspectionStepsEnum } from '~/shared/config/enums'

export const stepsConfigs = Object.values(InspectionStepsEnum)
export const firstStepConfig = stepsConfigs[0]
